/** A deadline covers headers and bodies; caller cancellation keeps its own reason. */
export function requestDeadline(signal, timeoutMs = 15000) {
    const controller = new AbortController();
    let timer, reject;
    const aborted = new Promise((_, fail) => { reject = fail; });
    void aborted.catch(() => {});
    const forward = () => controller.abort(signal.reason);
    const fail = () => reject(controller.signal.reason);
    controller.signal.addEventListener('abort', fail, { once: true });
    signal?.addEventListener('abort', forward, { once: true });
    const reset = () => {
        clearTimeout(timer);
        timer = setTimeout(() => controller.abort(new DOMException('Request timed out. Retry to reconnect.', 'TimeoutError')), timeoutMs);
    };
    reset();
    if (signal?.aborted) forward();
    return {
        signal: controller.signal, reset,
        wait: promise => Promise.race([promise, aborted]),
        dispose: () => { clearTimeout(timer); signal?.removeEventListener('abort', forward); controller.signal.removeEventListener('abort', fail); },
    };
}

export async function fetchJson(url, options = {}, { timeoutMs = 15000, fetcher = fetch } = {}) {
    const deadline = requestDeadline(options.signal, timeoutMs);
    try {
        const response = await deadline.wait(fetcher(url, { ...options, signal: deadline.signal }));
        if (!response.ok) throw Object.assign(new Error(`Request unavailable (${response.status}). Retry shortly.`), { status: response.status });
        return await deadline.wait(response.json());
    } finally { deadline.dispose(); }
}
